module.exports = __webpack_public_path__ + "img/InsLicht.bd4dcf1a.jpg";